import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, TextField, withStyles } from "@material-ui/core";
import t from "../../../languages/pl";
import UserEditableFields from './UserEditableFields';
import { indefinitePasswordExpiration } from "../../../utils/staticData";

const useStyles = theme => ({
    inputField: {
        margin: theme.spacing(1),
        minWidth: 250,
    },
});

const initialState = {
    email: "",
    username: "qsafe24.",
    name: "",
    expiration: 30,
    typ: ""
};

const NewUserForm = forwardRef((props, ref) => {
    const { classes, onBlur, onTypeChange } = props;
    const [state, setState] = useState(initialState);

    const handleChange = e => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    };

    const handleFormBlur = () => {
        onBlur && onBlur(state);
    };

    return (
            <UserEditableFields
                ref={ref}
                onChange={(editableFieldsState) => setState({ ...state, ...editableFieldsState })}
                onTypeChange={onTypeChange}
                onSubmit={handleFormBlur}
            >
                <TextField
                    label={t.passwordExpiration}
                    className={classes.inputField}
                    select
                    defaultValue={30}
                    name="expiration"
                    onChange={handleChange}
                >
                    <MenuItem value={30}>30&nbsp;{t.days}</MenuItem>
                    <MenuItem value={60}>60&nbsp;{t.days}</MenuItem>
                    <MenuItem value={90}>90&nbsp;{t.days}</MenuItem>
                    <MenuItem value={indefinitePasswordExpiration}>{t.noExpiration}</MenuItem>
                </TextField>
            </UserEditableFields>
    );
});

NewUserForm.displayName = "NewUserForm";

NewUserForm.propTypes = {
    classes: PropTypes.object,
    onBlur: PropTypes.func,
    onTypeChange: PropTypes.func
};

export default withStyles(useStyles)(NewUserForm);
